import constants from 'common/constants'

import {
  ENFORCE_MFA_TOGGLE,
  GENERATE_EMAIL_OTP,
  GENERATE_MFA_OTP,
  GET_EMAIL_VERIFICATION_STATUS,
  SEND_STUDENT_PARENT_VERIFICATION_EMAILS,
  VERIFY_EMAIL_OTP,
  VERIFY_MFA_OTP,
  VERIFY_STUDENT_PARENT_EMAIL,
} from './ActionTypes/ApiActionTypes'

export const getEmailVerificationStatus = (body, onSuccess, onFailure) => {
  return {
    type: GET_EMAIL_VERIFICATION_STATUS,
    payload: {
      onSuccess: onSuccess,
      onFailure: onFailure,
      apiUrl: 'user-security-details/email-verification-status',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
    },
  }
}

export const generateEmailOtp = (body, onSuccess, onFailure) => {
  return {
    type: GENERATE_EMAIL_OTP,
    payload: {
      onSuccess: onSuccess,
      onFailure: onFailure,
      apiUrl: 'user-security-details/generate-email-otp',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
    },
  }
}

export const verifyEmailOtp = (body, onSuccess, onFailure) => {
  return {
    type: VERIFY_EMAIL_OTP,
    payload: {
      onSuccess: onSuccess,
      onFailure: onFailure,
      apiUrl: 'user-security-details/verify-email-otp',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
    },
  }
}

export const generateMfaOtp = (body, onSuccess, onFailure) => {
  return {
    type: GENERATE_MFA_OTP,
    payload: {
      onSuccess: onSuccess,
      onFailure: onFailure,
      apiUrl: 'user-security-details/generate-mfa-otp',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
    },
  }
}

export const verifyMfaOtp = (body, onSuccess, onFailure) => {
  return {
    type: VERIFY_MFA_OTP,
    payload: {
      onSuccess: onSuccess,
      onFailure: onFailure,
      apiUrl: 'user-security-details/verify-mfa-otp',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
    },
  }
}

export const enforceMfaToggle = (body, onSuccess, onFailure) => {
  return {
    type: ENFORCE_MFA_TOGGLE,
    payload: {
      onSuccess: onSuccess,
      onFailure: onFailure,
      apiUrl: 'user-security-details/toggle-enforce-mfa',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
    },
  }
}

export const sendStudentParentVerificationEmails = (body, onSuccess, onFailure) => {
  return {
    type: SEND_STUDENT_PARENT_VERIFICATION_EMAILS,
    payload: {
      apiUrl: constants.api_bulk_send_student_parent_verification,
      getString: '',
      body,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const verifyStudentParentEmail = (body, onSuccess, onFailure) => {
  return {
    type: VERIFY_STUDENT_PARENT_EMAIL,
    payload: {
      apiUrl: constants.api_verify_student_parent_email,
      getString: '',
      body,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
